import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { getAttendanceColor } from 'helpers/attendance';
import { translate as getTranslate, Icon } from '@haldor/ui';
import TimeLineButton from './TimeLineButton';
import moment from 'moment';

var ItemContent = function ItemContent(props) {
  var _props$activities, _props$activities2;

  var event = props.event,
      lesson = props.lesson,
      attendance = props.attendance;
  var translate = getTranslate(useSelector(function (state) {
    return state.Languages.translations;
  }));
  var sectionTitle = null;

  if (props.view == 'month') {
    var _event$length5, _event$length6, _event$length7, _event$length8, _event$length9, _event$length10, _event$length11;

    var getTest = function getTest() {
      var _event$length, _event$length3;

      var test = 0;

      if (event !== null && event !== void 0 && (_event$length = event.length) !== null && _event$length !== void 0 && _event$length.ASSIGNMENT_TYPE_VERBAL_TEST) {
        var _event$length2;

        test += event === null || event === void 0 ? void 0 : (_event$length2 = event.length) === null || _event$length2 === void 0 ? void 0 : _event$length2.ASSIGNMENT_TYPE_VERBAL_TEST;
      }

      if (event !== null && event !== void 0 && (_event$length3 = event.length) !== null && _event$length3 !== void 0 && _event$length3.ASSIGNMENT_TYPE_WRITTEN_TEST) {
        var _event$length4;

        test += event === null || event === void 0 ? void 0 : (_event$length4 = event.length) === null || _event$length4 === void 0 ? void 0 : _event$length4.ASSIGNMENT_TYPE_WRITTEN_TEST;
      }

      return test;
    };

    return /*#__PURE__*/React.createElement("div", {
      className: "month-text"
    }, event.length.lesson > 0 && /*#__PURE__*/React.createElement("div", {
      className: "month-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "monthIcon lesson"
    }), /*#__PURE__*/React.createElement("span", null, event.length.lesson, " ", translate('Lessons'))), event.length.Assignment > 0 && /*#__PURE__*/React.createElement("div", {
      className: "month-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "monthIcon assignment"
    }), ' ', /*#__PURE__*/React.createElement("span", null, event === null || event === void 0 ? void 0 : (_event$length5 = event.length) === null || _event$length5 === void 0 ? void 0 : _event$length5.Assignment, " ", translate('Assignments'))), (event === null || event === void 0 ? void 0 : (_event$length6 = event.length) === null || _event$length6 === void 0 ? void 0 : _event$length6.meetings) > 0 && /*#__PURE__*/React.createElement("div", {
      className: "month-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "monthIcon meeting"
    }), ' ', /*#__PURE__*/React.createElement("span", null, event === null || event === void 0 ? void 0 : (_event$length7 = event.length) === null || _event$length7 === void 0 ? void 0 : _event$length7.meetings, " ", translate('Booked meetings'))), (event === null || event === void 0 ? void 0 : (_event$length8 = event.length) === null || _event$length8 === void 0 ? void 0 : _event$length8.unBooked) > 0 && /*#__PURE__*/React.createElement("div", {
      className: "month-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "monthIcon meeting"
    }), ' ', /*#__PURE__*/React.createElement("span", null, event === null || event === void 0 ? void 0 : (_event$length9 = event.length) === null || _event$length9 === void 0 ? void 0 : _event$length9.unBooked, " ", translate('Unbooked meetings'))), event !== null && event !== void 0 && (_event$length10 = event.length) !== null && _event$length10 !== void 0 && _event$length10.ASSIGNMENT_TYPE_WRITTEN_TEST || event !== null && event !== void 0 && (_event$length11 = event.length) !== null && _event$length11 !== void 0 && _event$length11.ASSIGNMENT_TYPE_VERBAL_TEST ? /*#__PURE__*/React.createElement("div", {
      className: "month-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "monthIcon test"
    }), ' ', /*#__PURE__*/React.createElement("span", null, getTest(), " ", translate('Test'))) : null);
  }

  if ((props === null || props === void 0 ? void 0 : (_props$activities = props.activities) === null || _props$activities === void 0 ? void 0 : _props$activities.type) === 'Meeting' && props.view !== 'agenda') {
    var meeting = props === null || props === void 0 ? void 0 : props.activities;
    return /*#__PURE__*/React.createElement("div", {
      className: "event-info"
    }, (meeting === null || meeting === void 0 ? void 0 : meeting.length) >= 30 ? /*#__PURE__*/React.createElement("div", {
      className: "agenda-event-title"
    }, meeting.title) : null, (meeting === null || meeting === void 0 ? void 0 : meeting.teamsMeeting) != null ? /*#__PURE__*/React.createElement("div", {
      className: "teams-meeting-indicator"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "Teams"
    })) : null, (meeting === null || meeting === void 0 ? void 0 : meeting.length) >= 40 ? /*#__PURE__*/React.createElement("div", {
      className: "size-12 event-meta"
    }, meeting === null || meeting === void 0 ? void 0 : meeting.instanceTitle) : null, (meeting === null || meeting === void 0 ? void 0 : meeting.length) >= 60 && meeting !== null && meeting !== void 0 && meeting.instanceStatus ? /*#__PURE__*/React.createElement("div", {
      className: "status-meeting"
    }, /*#__PURE__*/React.createElement("span", {
      className: "indicator-meeting",
      style: {
        backgroundColor: (meeting === null || meeting === void 0 ? void 0 : meeting.instanceStatus) === 'ACTIVE' ? '#DBDBDB' : '#19DB6C'
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: "indicator-title"
    }, (meeting === null || meeting === void 0 ? void 0 : meeting.instanceStatus) === 'ACTIVE' ? translate('meeting-not-completed') : translate('meeting-completed'))) : null);
  }

  if ((props === null || props === void 0 ? void 0 : (_props$activities2 = props.activities) === null || _props$activities2 === void 0 ? void 0 : _props$activities2.type) === 'Assignment' && props.view !== 'agenda') {
    var _assignment$section;

    var assignment = props === null || props === void 0 ? void 0 : props.activities;
    var endTime = moment.utc(assignment.startTime).set({
      second: 0,
      millisecond: 0
    }).local().add(assignment.length, 'minutes').format('LT');
    return /*#__PURE__*/React.createElement("div", {
      className: "event-info"
    }, /*#__PURE__*/React.createElement("div", null, endTime), /*#__PURE__*/React.createElement("div", {
      className: "agenda-event-title"
    }, assignment.title), (assignment === null || assignment === void 0 ? void 0 : assignment.length) >= 40 ? /*#__PURE__*/React.createElement("div", {
      className: "size-12 event-meta"
    }, assignment === null || assignment === void 0 ? void 0 : (_assignment$section = assignment.section) === null || _assignment$section === void 0 ? void 0 : _assignment$section.title) : null);
  }

  if ((lesson === null || lesson === void 0 ? void 0 : lesson.section) != null) {
    sectionTitle = lesson.section.title;
  }

  if ((lesson === null || lesson === void 0 ? void 0 : lesson.scheduleSubject) != null && (lesson === null || lesson === void 0 ? void 0 : lesson.scheduleSubject.extraInfo) != null) {
    sectionTitle = lesson.scheduleSubject.extraInfo;
  }

  var indicator = function indicator() {
    var indicatorColor = '#DBDBDB';
    var text = translate('not-reported-lesson');

    if (lesson.linkedSchedulePositions != null) {
      var reported = _toConsumableArray(lesson.linkedSchedulePositions.filter(function (lesson) {
        return lesson.attendanceReported != null;
      })).length;

      return /*#__PURE__*/React.createElement("div", {
        className: "status"
      }, /*#__PURE__*/React.createElement("span", {
        className: "indicator",
        style: {
          backgroundColor: reported == lesson.linkedSchedulePositions.length ? '#19DB6C' : '#DBDBDB'
        }
      }), reported, "(", lesson.linkedSchedulePositions.length, ") ", 'reported');
    }

    if (attendance != null) {
      indicatorColor = getAttendanceColor(attendance);
      text = translate(attendance.type.toLowerCase());
    } else {
      if (lesson.attendanceReported != null) {
        indicatorColor = '#19DB6C';
        text = translate('reported');
      }
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "status",
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "indicator",
      style: {
        backgroundColor: indicatorColor
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: "text"
    }, text));
  };

  if (props.view == 'agenda') {
    var _props$activities3, _props$activities4;

    if ((props === null || props === void 0 ? void 0 : (_props$activities3 = props.activities) === null || _props$activities3 === void 0 ? void 0 : _props$activities3.type) === 'Assignment') {
      var _assignment = props === null || props === void 0 ? void 0 : props.activities;

      return /*#__PURE__*/React.createElement("div", {
        className: "event-info"
      }, /*#__PURE__*/React.createElement("div", {
        className: "agenda-event-title"
      }, _assignment.title), /*#__PURE__*/React.createElement("div", null, sectionTitle != null ? sectionTitle : null));
    } else if ((props === null || props === void 0 ? void 0 : (_props$activities4 = props.activities) === null || _props$activities4 === void 0 ? void 0 : _props$activities4.type) === 'Meeting') {
      var _meeting = props === null || props === void 0 ? void 0 : props.activities;

      return /*#__PURE__*/React.createElement("div", {
        className: "event-info"
      }, /*#__PURE__*/React.createElement("div", {
        className: "agenda-event-title"
      }, _meeting.title), (_meeting === null || _meeting === void 0 ? void 0 : _meeting.teamsMeeting) != null ? /*#__PURE__*/React.createElement("div", {
        className: "teams-meeting-indicator"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Teams"
      })) : null, /*#__PURE__*/React.createElement("div", null, sectionTitle != null ? sectionTitle : null), _meeting !== null && _meeting !== void 0 && _meeting.instanceStatus ? /*#__PURE__*/React.createElement("div", {
        className: "status"
      }, /*#__PURE__*/React.createElement("span", {
        className: "indicator",
        style: {
          backgroundColor: (_meeting === null || _meeting === void 0 ? void 0 : _meeting.instanceStatus) === 'ACTIVE' ? '#DBDBDB' : '#19DB6C'
        }
      }), /*#__PURE__*/React.createElement("span", {
        className: "event-meta"
      }, (_meeting === null || _meeting === void 0 ? void 0 : _meeting.instanceStatus) === 'ACTIVE' ? translate('meeting-not-completed') : translate('meeting-completed'))) : null);
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "event-info"
    }, /*#__PURE__*/React.createElement("div", {
      className: "agenda-event-title"
    }, event.title, (lesson === null || lesson === void 0 ? void 0 : lesson.teamsMeeting) != null ? /*#__PURE__*/React.createElement(Icon, {
      name: "Teams"
    }) : null), /*#__PURE__*/React.createElement("div", null, sectionTitle != null ? sectionTitle : null), /*#__PURE__*/React.createElement("div", null, lesson === null || lesson === void 0 ? void 0 : lesson.room), /*#__PURE__*/React.createElement("div", {
      className: "event-meta"
    }, lesson !== null && lesson !== void 0 && lesson.attendanceReported || attendance != null ? indicator() : ' '));
  }

  if ((lesson === null || lesson === void 0 ? void 0 : lesson.length) >= 60) {
    return /*#__PURE__*/React.createElement("div", {
      className: "event-info",
      style: {
        width: '100%'
      }
    }, event.title, /*#__PURE__*/React.createElement("div", {
      className: "size-12 event-meta"
    }, indicator(), /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: 4
      }
    }, sectionTitle != null ? sectionTitle + (lesson.room != null ? " (".concat(lesson.room, ")") : '') : null)), (lesson === null || lesson === void 0 ? void 0 : lesson.teamsMeeting) != null ? /*#__PURE__*/React.createElement("div", {
      className: "teams-meeting-indicator",
      style: {
        width: 'auto'
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "Teams"
    })) : null);
  }

  if ((lesson === null || lesson === void 0 ? void 0 : lesson.length) >= 40) {
    return /*#__PURE__*/React.createElement("div", {
      className: "event-info",
      style: {
        width: '100%'
      }
    }, event.title, /*#__PURE__*/React.createElement("div", {
      className: "size-12 event-meta"
    }, lesson.attendanceReported || attendance != null || sectionTitle == null ? indicator() : lesson.room != null ? sectionTitle + (lesson.room != null ? " (".concat(lesson.room, ")") : '') : sectionTitle), (lesson === null || lesson === void 0 ? void 0 : lesson.teamsMeeting) != null ? /*#__PURE__*/React.createElement("div", {
      className: "teams-meeting-indicator",
      style: {
        width: 'auto'
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "Teams"
    })) : null);
  }

  if (event.id == 'custom_button') {
    return /*#__PURE__*/React.createElement(TimeLineButton, {
      time: event.start,
      toggleTimeButton: props.toggleTimeButton,
      open: props.open
    });
  }

  return /*#__PURE__*/React.createElement("div", null, event.title, (lesson === null || lesson === void 0 ? void 0 : lesson.teamsMeeting) != null ? /*#__PURE__*/React.createElement("div", {
    className: "teams-meeting-indicator"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "Teams"
  })) : null);
};

export default ItemContent;